module.exports = __webpack_public_path__ + "img/744.081f0411.jpg";